import React from "react";

const FeatureSection = () => {
  return (
<section id="features" class="py-10 container mx-auto px-6">
      <div class="container mx-auto px-6">
        <h3 class="text-xl font-bold italic text-center mb-10">Features</h3>
        <div class="grid gap-8 md:grid-cols-2">
          <div class="p-6 bg-gradient-to-r from-blue-100 via-blue-200 to-blue-200 shadow rounded-xl">
            <h4 class="font-semibold text-lg">Tournament Management</h4>
            <p class="text-gray-600">
              Create tournaments with knockout, league, or round-robin formats.
            </p>
          </div>
          <div class="p-6 bg-gradient-to-r from-blue-100 via-blue-200 to-blue-200 shadow rounded-xl">
            <h4 class="font-semibold text-lg">Teams & Players</h4>
            <p class="text-gray-600">
              Add team and player profiles, track stats & top performers.
            </p>
          </div>
          <div class="p-6 bg-gradient-to-r from-blue-100 via-blue-200 to-blue-200 shadow rounded-xl">
            <h4 class="font-semibold text-lg">Fixture Generator</h4>
            <p class="text-gray-600">
              Save hours with auto-generated balanced match schedules.
            </p>
          </div>
          <div class="p-6 bg-gradient-to-r from-blue-100 via-blue-200 to-blue-200 shadow rounded-xl">
            <h4 class="font-semibold text-lg">Live Scores & Leaderboards</h4>
            <p class="text-gray-600">
              Update match results instantly, keep fans engaged.
            </p>
          </div>
          <div class="p-6 bg-gradient-to-r from-blue-100 via-blue-200 to-blue-200 shadow rounded-xl">
            <h4 class="font-semibold text-lg">Digital Certificates</h4>
            <p class="text-gray-600">
              Generate winner and player certificates with your logo.
            </p>
          </div>
          <div class="p-6 bg-gradient-to-r from-blue-100 via-blue-200 to-blue-200 shadow rounded-xl">
            <h4 class="font-semibold text-lg">Promotion Tools</h4>
            <p class="text-gray-600">
              Share tournament pages & results on social media.
            </p>
          </div>
          <div class="p-6 bg-gradient-to-r from-blue-100 via-blue-200 to-blue-200 shadow rounded-xl">
            <h4 class="font-semibold text-lg">Reserve Playground</h4>
            <p class="text-gray-600">
            Onboard your playground, unlock the booking feature, and enable players to
            seamlessly reserve slots using our platform
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeatureSection;